import { useContext } from "react";
import { PepI18nContext, type PepI18nContextValue } from "./PepI18nContext";

export function usePepI18n(): PepI18nContextValue {
  const ctx = useContext(PepI18nContext);
  if (!ctx) throw new Error("usePepI18n must be used within PepI18nProvider");
  return ctx;
}
